import React from 'react'

const LowCoolant_Old = ({ width = '64px', height = '64px', color }) => (
  <svg version={1.1} id="Layer_1" x="0" y="0" viewBox="0 0 512 512" xmlSpace="preserve" width={width} height={height}>
    <g fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10}>
      <path strokeWidth={20} d="M255.566 102.893v206.33" />
      <path strokeWidth={20.146} d="M348.109 126.072h-91.557M348.109 187.33h-91.557M348.109 251.071h-91.557" />
      <path
        strokeWidth={20}
        d="M57.72 343.785s33.112-18.212 64.569 0 51.324 9.934 68.708.828M454.241 343.785s-33.112-18.212-64.569 0-51.324 9.934-68.708.828M111.528 394.282s26.206 29.265 71.192 5.795c38.079-19.867 42.218 7.45 72.019 7.45M399.605 394.282s-26.206 29.265-71.192 5.795c-38.079-19.867-42.218 7.45-72.019 7.45"
      />
      <circle strokeWidth={20} cx={256.222} cy={335.507} r={25.662} />
    </g>
  </svg>
)
export default LowCoolant_Old
